import { EllipsedText, FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Card } from 'baseui/card';
import { LabelSmall } from 'baseui/typography';
import { memo } from 'react';
import { useRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { notificationSelectedState } from '../../storage/notifications';
import { Notification } from '../../types/notification';
import NotificationBody from './NotificationBody';

type Props = {
  notification: Notification;
};

function HistoricNotificationItem({ notification }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const [selectedNotification, setSelectedNotification] = useRecoilState(notificationSelectedState);
  const isSelected = selectedNotification?._id === notification._id;

  if (!Object.keys(notification).length) return null;

  return (
    <Card
      overrides={{
        Root: {
          style: {
            height: 'calc(100% - 16px)',
            boxSizing: 'border-box',
            borderLeftWidth: isSelected ? '2px' : '1px',
            borderRightWidth: isSelected ? '2px' : '1px',
            borderTopWidth: isSelected ? '2px' : '1px',
            borderBottomWidth: isSelected ? '2px' : '1px',
            borderTopColor: isSelected ? theme.colors.borderSelected : theme.colors.borderOpaque,
            borderRightColor: isSelected ? theme.colors.borderSelected : theme.colors.borderOpaque,
            borderLeftColor: isSelected ? theme.colors.borderSelected : theme.colors.borderOpaque,
            borderBottomColor: isSelected ? theme.colors.borderSelected : theme.colors.borderOpaque,
            userSelect: 'none',
            cursor: 'pointer',
          },
          props: {
            onClick: () => {
              setSelectedNotification(notification);
            },
          },
        },
        Contents: {
          style: {
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            marginLeft: 0,
            padding: `${theme.sizing.scale300} ${theme.sizing.scale500}`,
          },
        },
        Body: {
          style: {
            marginBottom: 0,
          },
        },
      }}
    >
      <FlexColumn gap={theme.sizing.scale100}>
        <FlexRow
          classNames={css({
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
        >
          <LabelSmall>
            <EllipsedText inline>{notification.title || '-'}</EllipsedText>
          </LabelSmall>
        </FlexRow>
        <NotificationBody notification={notification} />
      </FlexColumn>
    </Card>
  );
}

export default memo(HistoricNotificationItem);
